import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { SrIcon } from "@/components/ui/SrIcon";
import { useLeadRules } from "@/hooks/use-lead-queue";
import { leadRulesText } from "@/lib/lead-queue";

/**
 * Infoikonet «Slik fordeles leads» (VIB-3050). Teksten bygges fra lead_rules(), altså de samme
 * verdiene databasen bruker, så tallene her aldri kan avvike fra det som faktisk skjer.
 */
export default function LeadRulesButton() {
  const [open, setOpen] = useState(false);
  const { data: rules, isLoading, error } = useLeadRules({ enabled: open });

  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setOpen(true)} aria-label="Slik fordeles leads">
        <SrIcon name="info" className="mr-1.5 h-4 w-4" />
        Slik fordeles leads
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Slik fordeles leads</DialogTitle>
            <DialogDescription>Reglene gjelder alle bookere. Tallene er de samme som systemet bruker.</DialogDescription>
          </DialogHeader>
          {isLoading ? (
            <Skeleton className="h-64 w-full" />
          ) : error ? (
            <p className="text-sm">{(error as Error).message}</p>
          ) : rules ? (
            <ol className="max-h-[60vh] space-y-3 overflow-y-auto pr-1 text-sm">
              {leadRulesText(rules).map((r, i) => (
                <li key={r.title} className="flex gap-3">
                  <span className="font-display font-semibold">{i + 1}</span>
                  <span>
                    <span className="font-medium">{r.title}.</span> {r.text}
                  </span>
                </li>
              ))}
            </ol>
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
